import "./view-logs.scss"
import React, { SetStateAction, useEffect, useState } from 'react'
import {faCircleArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Dispatch } from "redux";
import api from "api";
import { useQuery } from "hooks/query";
import { useParams } from "react-router";

interface props{
  setActiveWordBinLogs:any,
}

function ViewLogs({setActiveWordBinLogs}:props) {
 
  const [wordBinLogList,setWordBinLogList]=useState<any[]>([]);
  const query = useQuery();
  const params: any = useParams();

  useEffect(()=>{
      let val = params.reactionListId;
      
      if (val)
      api.reactionLists.getWordBinLogs(parseInt(val)).then(setWordBinLogList);
      console.log(wordBinLogList);
  },[])


  return (
      <div className="view-logs-div">
        <div className="margin-below">
          <div className="word-logs-top-split"> <FontAwesomeIcon className="move-down-icon" onClick={()=>setActiveWordBinLogs(false)} icon={faCircleArrowLeft} /><h4>Word Bin Logs</h4></div>
        </div>
        <table>
          <tr className="header-tr-vl">
            <th>
              ID
            </th>
            <th>
              Date From
            </th>
            <th>
              Date To
            </th>
            <th>
              Date Sent
            </th>
            <th>
              Clips
            </th>
          </tr>
          <tbody>
          {wordBinLogList.length!==0? ( wordBinLogList.map(item =>
                <tr key={item.Id}>
                    <td>{item.Id}</td>
                    <td>{item.DateFrom.slice(0,10)}</td>
                    <td>{item.DateTo.slice(0,10)}</td>
                    <td>{item.DateSent.slice(0,10)}</td>
                    <td>{item.ClipCount}</td>
                </tr>    
                  )):(
                    <tr className="default">
                        <td  colSpan={5}>{"This word bin has not been sent out"}</td>
                    </tr>
                )}
        </tbody>
        </table>
      </div>
  )
}

export default ViewLogs